import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  getPermissions: async ({ commit }) => {
    try {
      const res = await axios.get(`/permissions`);
      commit('mutatePermissions', res.data);
    } catch (err) {
      console.error(err);
      return;
    }
  }
};

export const mutations = {
  mutatePermissions: (state, payload) => {
    state.permissions = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    permissions: []
  };
}
